import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { BuilderHotelExperience } from 'app/typings/core/builder/experiences';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useBuilderHotelExperiences(hotelId?: number) {
  return useQuery<BuilderHotelExperience[] | null>({
    queryKey: [CORE_QUERY_KEYS.builderExperiences, { id: hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getExperiences,
            params: { id: hotelId.toString() },
          }) as Promise<BuilderHotelExperience[]>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
